<template>
  <section-view :title="title" :tips="tips">
    <div ref="chart" :class="['chart', {multiple: this.list.length > 3 || this.list.length === 0}]"></div>
  </section-view>
</template>

<script>
  import SectionView from "@/components/SectionView";
  import {rgba2rgb} from "../utils/Helper";
  /**
   * 关系图卡片
   */
  export default {
    name: "GraphCard",
    components: {SectionView},

    props: {
      // 提示
      tips: {
        type: Boolean,
        default: false
      },
      // 标题
      title: {
        type: String,
        require: true
      },
      // 主元素
      main: {
        type: String,
        require: true
      },
      // 主元素颜色
      color: {
        type: String,
        default: '#3BA272'
      },
      // 元素
      list: {
        type: Array,
        require: true
      }
    },

    watch: {
      list() {
        this.$nextTick(() => {
          this.update();
        });
      }
    },

    mounted() {
      if (this.list.length > 0) {
        this.update();
      }
    },

    methods: {
      // 渲染
      update() {
        let el = this.$refs.chart;
        const chart = this.$echarts.init(el);

        let data = [], links = [];
        let series = {
          type: 'graph',
          roam: false,
          label: {
            show: true,
            color: '#ffffff'
          },
          width: 200,
          data: data,
          links: links,
          lineStyle: {
            opacity: 1,
            width: 2,
            curveness: 0,
            color: '#888888'
          }
        };

        // 低于三个数据项时使用特殊样式
        if (this.list.length <= 3) {
          series.layout = 'none';
          // 生成主元素
          data.push(this.item(this.main, 20, 70, this.color, 90, 18));
          const x = [150, 180, 200], y = [0, 50, 100], c = [0.3, 0.2, -0.2];
          // 生成其他元素
          this.list.forEach((item, index) => {
            data.push(this.item(item.item_dict_name_simple, x[index], y[index], item.color, 50));
            links.push({
              source: 0,
              target: index + 1,
              lineStyle: { curveness: c[index] }
            });
          });
        } else {
          // 生成主元素
          data.push(this.item(this.main, null, null, this.color, 90, 18));
          // 生成其他元素
          this.list.forEach((item, index) => {
            data.push(this.item(item.item_dict_name_simple, null, null, item.color, 50));
            links.push({
              source: 0,
              target: index + 1
            });
          });

          series.layout = 'force';
          series.force = {
            layoutAnimation: false,
            repulsion: 200,
            edgeLength: 100
          };
        }

        chart.setOption( {
          tooltip: null,
          animationDurationUpdate: 1500,
          animationEasingUpdate: 'quinticInOut',
          series: [series]
        });

        chart.on('click', (e) => {
          if (e.dataType === 'node' && e.dataIndex > 0) {
            this.$emit('select', e.dataIndex);
          }
        })
      },

      // 生成元素
      item(name, x, y, color, size, fontSize = 11) {
        return {
          name: name,
          x: x,
          y: y,
          symbolSize: size,
          edgeLabel: {
            fontSize: 40,
          },
          label: {
            fontSize: fontSize
          },
          itemStyle: {
            color: {
              type: 'radial',
              x: 0.5,
              y: 0.5,
              r: 0.5,
              colorStops: [
                {
                  offset: 0, color: rgba2rgb(color + '88', 255)
                },
                {
                  offset: 1, color: color
                }
              ]
            }
          }
        };
      }
    }
  }
</script>

<style lang="scss" scoped>
  .chart {
    height: 412px;

    &.multiple {
      height: 600px;
    }
  }
</style>